export default "__VITE_ASSET__ClXm0013__"